<template>
  <el-select :disabled="disabled" filterable :clearable='clearable' @change="handleChange" :value="data.value" :placeholder="$t('请选择')"
             @clear="handleChange">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in operator" :key="index"></el-option>
  </el-select>
</template>

<script>
    import {loadSIMClient} from '@/services/factory'
    // import { findList } from "@/services/customer";

    export default {
        name: 'Operator',
        props: {
            value: {},
            disabled: {
                type: Boolean,
                default: false 
            },
            clearable:{
                type: Boolean,
                default: true
            }
        },

        data() {
            return {data: {}, operator: []}
        },
        watch: {
            value:{
                immediate:true,
                handler(value){
                    if (value) {
                            this.data = value;
                        } else {
                            this.data = {};
                        }

                }
            }
        },
        mounted() {
            this.loadData();
        },
        methods: {
            setSelectValue(value) {
                this.data = {
                    value: value,
                    name: ""
                }
            },
            handleChange(value) {
                
                let find = this.operator.find((item, i) => {
                    return item.value == value
                })
                if (!find) {
                    find = {};
                }
               
                if (find==undefined) {
                    find = "";
                }
                this.$emit("input", {...find});
                this.$emit("change", {...find});
                this.data = {...find};
            },
            async loadData() {
               
                const response = await loadSIMClient();
                 if (response&&response.code==0) {
                    this.operator = response.data.map((item, i) => {
                        return {name: item.clientName, value: item.clientId}
                    })
                }
            }

        }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/operation/dishuOperator.vue